import type { EventBusKey } from "@vueuse/core";

export const registryConnectionsChanged: EventBusKey<number> = Symbol(
  "registryConnectionsChanged"
);
